<div class="pt-3" style="width:100%; padding-right:0px">
    <div class="main">
        <div class="header">
            <div class="iconContainer">
                <i class="fa fa-arrow-left" (click)="backIconClick()" style="cursor: pointer;"></i>
            </div>
            <div style="font-size: 20px; margin-left:15px; font-weight:600; font-family:Raleway;">Add Mapping</div>
        </div>

        <div class="formContainer">
            <div class="mappingForm shadow">
                <div class="formHeader">
                    <div class="headerText">Add Mapping</div>
                    <i class="fa fa-times closeIcon" (click)="backIconClick()" style="cursor: pointer;"
                        aria-hidden="true"></i>
                </div>

                <form [formGroup]="mappingForm">
                    <!-- <select formControlName="cse_name">
                        <option value="">Select CSE <sup *ngIf="mappingForm.get('cse_name').invalid">*</sup></option>
                        <option *ngFor="let cseDetail of cseList" [name]="cseDetail.name" [value]="cseDetail.id">
                            {{cseDetail.name}}
                        </option>
                    </select> -->

                    <mat-form-field appearance="outline">
                        <mat-label>Select CSE <sup *ngIf="mappingForm.get('cse_id').invalid">*</sup></mat-label>
                        <mat-select formControlName="cse_id" [disabled]="isUpdate">
                            <mat-option *ngFor="let cseDetail of cseList" [value]="cseDetail.id">
                                {{cseDetail.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="mappingForm.get('cse_id').invalid">Please Select CSE Name</mat-error>
                    </mat-form-field>

                    <!-- <select formControlName="facility_name">
                        <option value="">Select Facility <sup *ngIf="mappingForm.get('facility_name').invalid">*</sup>
                        </option>
                        <option *ngFor="let facilityDetail of facilityList" [name]="facilityDetail.facility_name"
                            [value]="facilityDetail.id">
                            {{facilityDetail.facility_name}}
                        </option>
                    </select> -->

                    <mat-form-field appearance="outline">
                        <mat-label>Select Facility <sup
                                *ngIf="mappingForm.get('facility_id').invalid">*</sup></mat-label>
                        <mat-select formControlName="facility_id" multiple (selectionChange)="facilitySelected($event)">

                            <input (input)="searchOnDropdown($event.target.value)" placeholder="Seach Facility"
                                class="seachFacilityDropdown">
                                
                            <mat-option *ngFor="let facilityDetail of facilityList" [value]="facilityDetail.id">
                                {{facilityDetail.facility_name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="mappingForm.get('facility_id').invalid">Please Select Facility
                            Name</mat-error>
                    </mat-form-field>

                    <div class="buttonContainer">
                        <button type="button" (click)="cancelClick()" class="cancelBtn">CANCEL</button>
                        <button type="button" (click)="submitForm()"
                            [ngClass]=" mappingForm.valid ? 'cfnMapping' : 'diableMapSubmitBtn'">
                            {{submitBtnText}}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>